var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"icon-advisor",attrs:{"href":"https://wezift.com/parent-portal/app-advisor/","target":"_blankManageRequestsHeaderIcon"},on:{"click":_vm.openAppAdvisor}},[_c('icon-app-advisor',{attrs:{"width":"48","height":"48","iconColor":"#fff"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }